import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { ArrowLeft } from "@phosphor-icons/react";

export default function AboutPage() {
  const { username } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/sites/${username}`);
        setData(data);
      } catch (e) { setErr("Author not found"); }
    })();
  }, [username]);

  if (err) return <div className="max-w-3xl mx-auto px-6 py-32 text-center"><h1 className="font-serif text-4xl">{err}</h1></div>;
  if (!data) return <div className="max-w-3xl mx-auto px-6 py-20 text-muted-foreground">Loading...</div>;
  const { author } = data;

  return (
    <div className="max-w-3xl mx-auto px-6 pt-12 pb-24">
      <Link to={`/${username}`} className="link-underline text-sm text-muted-foreground inline-flex items-center gap-2" data-testid="about-back-link">
        <ArrowLeft size={14} /> Back to journal
      </Link>
      <div className="mt-10 flex items-center gap-5">
        {author.profile_picture ? (
          <img src={fileUrl(author.profile_picture)} alt="" className="h-20 w-20 object-cover" />
        ) : (
          <div className="h-20 w-20 bg-secondary grid place-items-center font-serif text-3xl">{(author.name || "A")[0]}</div>
        )}
        <div>
          <div className="eyebrow text-muted-foreground">About</div>
          <h1 className="font-serif text-5xl font-black tracking-tight leading-tight">{author.name}</h1>
          <div className="text-muted-foreground mt-1">{author.bio || ""}</div>
        </div>
      </div>
      <div className="mt-12 article-prose" data-testid="about-body" dangerouslySetInnerHTML={{ __html: author.about_page || "<p class='text-muted-foreground'>This author hasn't written an about page yet.</p>" }} />
    </div>
  );
}
